import styled from '@emotion/styled'
import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import Link from '@/modules/components/Link'
import Typography from '@/modules/components/Typography'

import type { Learn } from '../../data/types'

const Line = styled(Box)`
  width: 2px;
  height: 40px;
  background: #1199fa;
  margin-right: 16px;
`
const MotionItem: React.FC = ({ children }) => {
  return (
    <motion.div
      variants={{
        open: { scale: 1 },
        collapsed: { scale: 1 },
      }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.div>
  )
}

export const LearnMenu = ({
  menuData,
  onMenuItemClick,
}: {
  menuData: Learn[]
  onMenuItemClick: () => void
}) => {
  const { t } = useTranslation('navigation')

  return (
    <>
      <Box
        bg={'#F7F9FA'}
        style={{
          boxShadow:
            'inset 0px 4px 4px rgba(0, 45, 116, 0.05), inset 0px -4px 4px rgba(0, 45, 116, 0.05)',
        }}
      >
        <AnimatePresence>
          {menuData.map((item, i) => (
            <MotionItem key={item.tTitle}>
              <Link href={item.href} onClick={onMenuItemClick}>
                <Flex
                  key={item.tTitle}
                  pl={[5, 9]}
                  py={1.5}
                  alignItems={'center'}
                  borderBottom={
                    i !== menuData.length - 1 ? '2px solid #fff' : 0
                  }
                >
                  <Line />
                  <Box mt={'2px'}>
                    <Typography variant="menuTitle" color="#061121" mb={'2px'}>
                      {t(item.tTitle)}
                    </Typography>
                    <Typography variant="menuDescription" color="#7B849B">
                      {t(item.tDesc)}
                    </Typography>
                  </Box>
                </Flex>
              </Link>
            </MotionItem>
          ))}
        </AnimatePresence>
      </Box>
    </>
  )
}
